<template>
    <b-navbar
        v-if="loggedIn"
        type="dark"
        variant="dark"
        :sticky="true"
    >
        <button
            @click="() => $emit('input', !value)"
            class="sc-toggler"
        >
            <font-awesome-icon icon="bars"></font-awesome-icon>
        </button>
      <LogoNavbarBrand/>
      <b-navbar-nav v-if="user" class="ml-auto">
        <b-nav-item-dropdown
          href="#"
          right
        >
          <template v-slot:button-content>
              <font-awesome-icon icon="user-circle"></font-awesome-icon>
              <div class="desktop-only ml-2">Hello, {{ user.person.first_name }}!</div>
          </template>
          <b-dropdown-item
            :to="{ name: 'my_account' }"
          >
            <font-awesome-icon class="mr-2" icon="user-cog" />
            Account
          </b-dropdown-item>
          <b-dropdown-item
            :to="{ name: 'activity' }"
          >
            <font-awesome-icon class="mr-2" icon="user-shield" />
            Activity
          </b-dropdown-item>
          <b-dropdown-item
            :to="{ name: 'login' }"
            @click="logout"
          >
            <font-awesome-icon class="mr-2" icon="sign-out-alt"></font-awesome-icon>
            Sign out
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
</template>
<script>
import { mapState } from 'vuex'
import LogoPlaceholder from '@/components/logo/LogoPlaceholder.vue';
import LogoNavbarBrand from "@/components/logo/LogoNavbarBrand.vue";
export default {
    props: {
        value: { type: Boolean }
    },
    components: { LogoPlaceholder, LogoNavbarBrand },
    methods: {
        logout() {
            localStorage.removeItem("token");
            this.$store.commit("logout");
            this.$router.push("/account/login");
            this.$bvToast.toast('You are logged out.', {
                title: 'Logged Out',
                autoHideDelay: 5000,
                appendToast: true
            });
        }
    },
    computed: mapState(["loggedIn", "user"])
}
</script>